// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2QPyZ","rightAdornment":"Header_rightAdornment__3yIM1"};